import { useRef } from 'react';

/**
 * Creates a stable `<div style="display:contents">` DOM element on first
 * render and returns the same element on every subsequent render.
 *
 * The element is created lazily on first access via `useRef` — not via
 * `useMemo` — so StrictMode / cache-eviction cannot cause it to be
 * recreated and break referential stability for callers that capture it
 * (e.g. `createPortal`).
 *
 * @internal
 */
export function useStableHost(): HTMLDivElement {
  const hostRef = useRef<HTMLDivElement | null>(null);
  if (hostRef.current === null) {
    const el = document.createElement('div');
    el.style.display = 'contents';
    hostRef.current = el;
  }
  return hostRef.current;
}
